import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { findLang } from '../../../common/models/lang';
import { EXTERNAL_LINKS } from '../../../constants';

const Terms = () => {
    const { t, i18n } = useTranslation();

    return (
        <Stack sx={{ alignItems: 'center' }}>
            <Typography variant="caption" component="div" sx={{ maxWidth: '600px', textAlign: 'center' }}>
                {t('booking.acceptTerms1')}{' '}
                <Typography
                    variant="caption"
                    component="a"
                    sx={{ color: 'primary.main' }}
                    href={EXTERNAL_LINKS[findLang(i18n.language).i18nCode].terms}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {t('booking.acceptTerms2')}
                </Typography>{' '}
                {t('booking.acceptTerms3')}{' '}
                <Typography
                    variant="caption"
                    component="a"
                    sx={{ color: 'primary.main' }}
                    href={EXTERNAL_LINKS[findLang(i18n.language).i18nCode].policy}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {t('booking.acceptTerms4')}{' '}
                </Typography>
                {t('booking.acceptTerms5')}
            </Typography>
        </Stack>
    );
};

export { Terms };
